/**
 * @author github.com/frontend-collective
 * @see https://github.com/frontend-collective/react-image-lightbox
 * @license MIT
 */

 /*
 The MIT License (MIT)

Copyright (c) 2016 Chris Fritz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

/**
 * Placeholder for future translate functionality
 */
export function translate(str, replaceStrings = null) {
    if (!str) {
      return '';
    }
  
    let translated = str;
    if (replaceStrings) {
      Object.keys(replaceStrings).forEach(placeholder => {
        translated = translated.replace(placeholder, replaceStrings[placeholder]);
      });
    }
  
    return translated;
  }
  
  export function getWindowWidth() {
    return typeof global.window !== 'undefined' ? global.window.innerWidth : 0;
  }
  
  export function getWindowHeight() {
    return typeof global.window !== 'undefined' ? global.window.innerHeight : 0;
  }
  
  // Get the highest window context that isn't cross-origin
  // (When in an iframe)
  export function getHighestSafeWindowContext(self = global.window.self) {
    // If we reached the top level, return self
    if (self === global.window.top) {
      return self;
    }
  
    const getOrigin = href => href.match(/(.*\/\/.*?)(\/|$)/)[1];
  
    // If parent is the same origin, we can move up one context
    // Reference: https://stackoverflow.com/a/21965342/1601953
    if (getOrigin(self.location.href) === getOrigin(self.document.referrer)) {
      return getHighestSafeWindowContext(self.parent);
    }
  
    // If a different origin, we consider the current level
    // as the top reachable one
    return self;
  }